import type { SelectHTMLAttributes } from 'react';
import styles from './Select.module.css';

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  const { className, ...rest } = props;
  return <select className={[styles.select, className ?? ''].join(' ')} {...rest} />;
}
